import { FC, ChangeEvent } from 'react'
import {
  DefaultFormContainer,
  FormItemTitle,
  FormItemSubtitle,
  FormRadioContainer
} from './styles'
import StandardRadio from '../../basic/StandardRadio'
import StandardInput from '../../basic/StandardInput'
import { LeftBar } from '../../basic/LeftBar'
import { useErrors } from 'src/context/errors'

interface FirmPracticeTypeProps {
  setPracticeType: (type: string) => void;
  practiceType?: string;
  isIncorrect?: boolean;
  errorCode?: string;
}

const practiceTypes = [
  'Individual',
  'LLP',
  'Partnership',
  'PLLC',
  'PC',
  'Joint Venture'
]

const FirmPracticeType: FC<FirmPracticeTypeProps> = ({ setPracticeType, practiceType, isIncorrect, errorCode = '', }) => {
  const { hasError } = useErrors()

  isIncorrect = hasError(errorCode) || isIncorrect

  const handleRadioChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    if (value === 'Other') {
      setPracticeType('')
    } else {
      setPracticeType(value)
    }
  }

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.trim() === '') {
      setPracticeType('')
    } else {
      setPracticeType(event.target.value)
    }
  }

  const handleShowOther = () => {
    if (practiceType !== undefined && !practiceTypes.includes(practiceType)) return true

    return false
  }

  return (
    <DefaultFormContainer>
      <FormItemTitle>Type of practice</FormItemTitle>
      <FormItemSubtitle>Please select one option.</FormItemSubtitle>
      <FormRadioContainer>
        {practiceTypes.map((pt, index) => (
          <StandardRadio
            key={index}
            label={pt}
            value={pt}
            onChange={handleRadioChange}
            checked={practiceType === pt}
            variant="outlined"
            isIncorrect={isIncorrect}
            errorCode={errorCode}
          />
        ))}
        <StandardRadio
          label='Other'
          value="Other"
          onChange={handleRadioChange}
          checked={handleShowOther()}
          variant="outlined"
          isIncorrect={isIncorrect}
          errorCode={errorCode}
        />
        {handleShowOther() ? (
          <div style={{ display: 'flex', gap: '16px' }}>
            <LeftBar />
            <StandardInput
              label="Other type of practice"
              onChange={handleInputChange}
              value={practiceType ?? ''}
            />
          </div>
        ) : null}
      </FormRadioContainer>
    </DefaultFormContainer>
  )
}

export default FirmPracticeType